import { createReducer, INITIAL_STATE } from '../../shared/redux';
import { buildFetchTeamMembersApiConfig } from './team.api';
import { LOAD_STATE } from '../../shared/axios';
import { createHashOfArray } from '../../shared/utils/array';

export const FETCH_TEAM_MEMBERS_REQUEST_CALLED = '@team/FETCH_TEAM_MEMBERS_REQUEST_CALLED';
export const FETCH_TEAM_MEMBERS_REQUEST_SUCCEEDED = '@team/FETCH_TEAM_MEMBERS_REQUEST_SUCCEEDED';
export const FETCH_TEAM_MEMBERS_REQUEST_FAILED = '@team/FETCH_TEAM_MEMBERS_REQUEST_FAILED';

export const getTeam = state => state.team.data;
export const getTeamDataLoading = state => state.team.loadState;

export const fetchTeamMembers = () => ({
    type: FETCH_TEAM_MEMBERS_REQUEST_CALLED,
    actionTypes: {
        success: FETCH_TEAM_MEMBERS_REQUEST_SUCCEEDED,
        fail: FETCH_TEAM_MEMBERS_REQUEST_FAILED,
    },
    config: buildFetchTeamMembersApiConfig(),
});

const initialState = {
    loadState: LOAD_STATE.LOADING,
    data: {},
    error: null,
};

export const teamMembersReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [FETCH_TEAM_MEMBERS_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        error: null,
    }),
    [FETCH_TEAM_MEMBERS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: createHashOfArray(action.payload.data, 'id'),
        error: null,
    }),
    [FETCH_TEAM_MEMBERS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
});
